export class TokenBilling {
  constructor ({ supported, getSession, isCurrent, synchronizeIdentity, nativeCall }) {
    Object.assign(this, { supported, getSession, isCurrent, synchronizeIdentity, nativeCall })
  }

  ensure = async () => {
    if (!this.supported()) return { environment: 'Production' }
    const session = this.getSession()
    const assertCurrent = () => {
      if (!session.authUID || !this.isCurrent(session) || this.getSession().providerKey !== session.providerKey) {
        throw new Error('The IntelliKey account changed.')
      }
    }
    assertCurrent()
    const key = `${session.authGeneration}:${session.authUID}:${session.providerKey || ''}`
    if (this.current?.key === key && this.current.expiresAt > Date.now() + 60000) return this.current.context
    if (this.pending?.key === key) return this.pending.promise
    const promise = (async () => {
      await this.synchronizeIdentity()
      assertCurrent()
      const context = await this.nativeCall('tokenPurchases', { operation: 'billingContext' }, 60000)
      assertCurrent()
      if (context?.ok !== true || !['Production', 'Sandbox'].includes(context.environment) ||
          (context.environment === 'Sandbox' && (!/^[a-f0-9]{64}$/.test(context.session || '') ||
            !(context.expiresAt > Date.now() + 60000)))) throw new Error('Purchases are unavailable.')
      this.current = { key, context, expiresAt: context.environment === 'Sandbox' ? context.expiresAt : Infinity }
      return context
    })()
    this.pending = { key, promise }
    try { return await promise } finally {
      if (this.pending?.promise === promise) this.pending = null
    }
  }

  headers = async () => {
    const context = await this.ensure()
    return context.environment === 'Sandbox' ? { 'X-IntelliKey-Billing-Session': context.session } : {}
  }
}
